module.exports = __webpack_public_path__ + "static/media/SolutionsThird.9eb6ec38.png";